import { Avatar } from '@mokoboko/components';

import { ChevronDown } from '@/icons';
import { getAbbreviatedName, mergeClassNames } from '@/lib/utils';
import type { AdminUser } from '@/state/admin-users';

const PILL_BASE =
  'relative inline-flex items-center gap-2.5 rounded-full bg-white py-1.5 pl-1.5 pr-2.5 shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] after:pointer-events-none after:absolute after:inset-0 after:rounded-full after:ring-1 after:ring-inset after:ring-black/[0.12] after:shadow-[inset_0_-2px_0_0_rgba(24,29,39,0.06)]';

type PillInstructor = Pick<AdminUser, 'first_name' | 'profile_picture'> & {
  last_name?: string | null;
};

export const InstructorPill = ({
  instructor,
  compact = false,
  onClick,
}: {
  instructor: PillInstructor;
  compact?: boolean;
  onClick: () => void;
}) => {
  const name = getAbbreviatedName(instructor.first_name, instructor.last_name);

  return (
    <button
      type="button"
      onClick={onClick}
      className={mergeClassNames(
        PILL_BASE,
        'mb-focus-visible group transition-colors duration-200 hover:bg-gray-100',
        compact && 'h-9 max-w-full gap-2 pr-3'
      )}
    >
      <Avatar
        aria-hidden
        name={name}
        src={instructor.profile_picture ?? undefined}
        size={compact ? 'xs' : 'sm'}
      />
      <span
        className={mergeClassNames(
          'text-sm font-medium text-gray-900 transition-colors group-hover:text-red-400',
          compact && 'min-w-0 truncate'
        )}
      >
        {name}
      </span>
      <span className="inline-flex shrink-0 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
        <ChevronDown rotate={-90} className="h-4 w-4 text-red-400" />
      </span>
    </button>
  );
};
